import React, { useEffect } from 'react'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import RecentlyUsedImage from './ImageItem'
import { IBaseMediaItem } from 'types/media'
import { useSelector } from 'react-redux'
import RecentlyUsedVideo from './VideoItem'
import { convertBaseItemToMediaItem } from 'utils/media'
import { DEFAULT_MEDIA_DURATION, imageTypes } from 'consts'
import { scrollToElementById } from 'utils'
import useDurationLimitCheck from 'hooks/useDurationLimitCheck'
import { userSelectors } from 'store/features/user/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { T } from 'consts/translationKeys'
import { dispatch } from 'store'
import { recentlyUsedMediaThunks } from 'store/features/recentlyUsedMedia/thunks'
import { recentlyUsedMediaSelectors } from 'store/features/recentlyUsedMedia/selectors'
import { editorThunks } from 'store/features/editor/thunks'
import { Text } from 'common-components'
import { useInsertionStartTime } from 'hooks/timeline/useInsertionStartTime'

const RecentlyUsed: React.FC = () => {
  const userData = useSelector(userSelectors.data)
  const userId = userData?.id
  const { width: projectDefaultWidth, height: projectDefaultHeight } =
    useSelector(projectDataSelectors.defaultDimensions)
  const recentlyUsedItems = useSelector(
    recentlyUsedMediaSelectors.externalMediaItems
  )
  const { isDurationAllowed } = useDurationLimitCheck()
  const getInsertionStartTime = useInsertionStartTime()

  useEffect(() => {
    if (userId) {
      dispatch(recentlyUsedMediaThunks.filterAndUpdateRecentlyUsedItems())
    }
  }, [userId])

  const handleAddMediaFromRecents = (item: IBaseMediaItem) => () => {
    const totalNewDuration = item.duration || DEFAULT_MEDIA_DURATION

    if (!isDurationAllowed(totalNewDuration)) {
      dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
      return
    }

    const preparedItem = convertBaseItemToMediaItem(
      item,
      getInsertionStartTime(totalNewDuration),
      {
        width: projectDefaultWidth,
        height: projectDefaultHeight
      }
    )

    dispatch(
      projectDataThunks.addMediaItems({
        value: [preparedItem],
        config: { applySelection: false }
      })
    )
    dispatch(
      editorThunks.setActiveTimelineItems([
        {
          id: preparedItem.id,
          type: preparedItem.type
        }
      ])
    )
    dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
    scrollToElementById(preparedItem.id)
  }

  if (recentlyUsedItems.length === 0) {
    return null
  }

  return (
    <Styled.RecentlyUsedContainer>
      <Text type="h2" fontWeight="600" color="secondarySemiDark">
        {translate(T.RECENT_MEDIAS_LABEL)}
      </Text>
      <Styled.RecentlyUsedItemsList>
        {recentlyUsedItems.map((item: IBaseMediaItem) => {
          return imageTypes.includes(item.type) ? (
            <RecentlyUsedImage
              key={`${item.path}-${item.mediaId}`}
              src={item.path ?? undefined}
              onClick={handleAddMediaFromRecents(item)}
            />
          ) : (
            <RecentlyUsedVideo
              key={`${item.path}-${item.mediaId}`}
              src={item.path ?? undefined}
              duration={item.duration}
              onClick={handleAddMediaFromRecents(item)}
              fileName={item.fileName}
            />
          )
        })}
      </Styled.RecentlyUsedItemsList>
    </Styled.RecentlyUsedContainer>
  )
}

export default RecentlyUsed
